<template>
  <div class="left-nav " :class="isHide?'hide-menu':'show-menu'">
    <el-menu :router="true" default-active="/adminHome" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" class="admin-menu">
      
      <!-- <el-menu-item @click="goChatting" v-if="typeCode == 4">
        <i class="el-icon-s-home"></i>
        <span slot="title">{{$t('msg.onlineService')}}</span>
      </el-menu-item> -->

      <!-- <li @click="goChatting" v-hasPermi="['onlineService']" class="el-menu-item" style="padding-left: 20px; color: #fff; background-color: rgb(84, 92, 100);">
        <i class="el-icon-s-home"></i> <span>{{$t('msg.onlineService')}}</span>
      </li> -->

      <SidebarItem v-for="item in $store.state.menuList" :item="item" :key="item.menuId" />

    </el-menu>
     <div class="menu-btn" @click="closeMenu">
       <i v-if='isHide' class="el-icon-arrow-right"></i>
       <i v-else class="el-icon-arrow-left"></i>
      </div>
   </div>
</template>

<script>
import {mapState} from 'vuex'
import SidebarItem from "./SidebarItem.vue";
export default {
  name: "UserMenu",
  components: {
    SidebarItem
  },
  data() {
    return {
      typeCode: this.$store.state.typeCode,
      isHide: false,
      menuList: []
    };
  },
  created() {
    setTimeout(() => {
      this.$store.dispatch("getMenuList");
    }, 500);
  },
  computed: {
    ...mapState(['typeCode','id'])
  },
  methods: {
    goChatting() {
      // let url = `/#/admin/chattingOnline`;
      // window.open(
      //   url,
      //   "chat",
      //   "height=600, width=800, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no"
      // );
      this.$router.push('/admin/chattingOnline');
    },
    closeMenu() {
      this.isHide = !this.isHide;
    }
  }
};
</script>

<style scoped>
.left-nav {
  position: fixed;
  left: 0;
  top: 61px;
  width: 280px;
  animation-name: showMenu;
  animation-duration: 0.2s;
   z-index: 99999;
}
.menu-btn {
  position: absolute;
  height: 40px;
  line-height: 40px;
  width: 30px;
  padding: 0 5px;
  border-radius: 28px;
  right: -20px;
  top: 50%;
  margin-top: -20px;
  background: rgb(84, 92, 100);
  color: #fff;
  z-index: 99998;
  text-align: right;
}
.menu-btn:hover {
  cursor: pointer;
}
.admin-menu {
  height: calc(100vh - 60px);
  padding-bottom: 60px;

  overflow-y: auto;
  overflow-x: hidden;
  border: none;
}
.hide-menu {
  animation-name: hideMenu;
  animation-duration: 0.5s;
  /* animation-delay: 1s; */
  animation-fill-mode: forwards;
}

@keyframes hideMenu {
  0% {
    width: 280px;
  }
  100% {
    width: 0;
  }
}
@keyframes showMenu {
  0% {
    width: 0;
  }
  100% {
    width: 280px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/admin/AdminMenu.vue